<template>
  <div>
    <div
        v-click-outside="() => showTooltip = false"
        class="pos-relative h-100 d-flex">
      <header-notifications-link
          :has-new-notifications="notificationsMetadata.hasUnseen"
          :class="{'router-link-active': $route.name === 'dashboard::pro::notifications'}"
          class="x-header-link"
          selenium="header-notification-link"
          tabindex="0"
          @click.native="notificationBellClick"
          @keypress.native.enter.space="notificationBellClick"
      />
      <transition
          name="list"
          mode="out-in">
        <div v-if="showTooltip" class="TOOLTIP">
          <notification-list
              v-infinite-scroll="notificationsMetadata.hasMore && fetchMoreNotifications"
              :meta="notificationsMetadata"
              :grouped-notifications="dateGroupedNotifications"
              class="TOOLTIP-CONTENT"
              @notificationClick="notificationClick"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import HeaderNotificationsLink from '@/layouts/components/HeaderNotificationsLink';
import NotificationList from '@/views/Dashboard/views/Notifications/components/NotificationList';
import notifications from '@/mixins/notifications';

export default {
  name: 'app-header-notificatons',
  components: {
    NotificationList,
    HeaderNotificationsLink,
  },
  mixins: [
    notifications,
  ],
  data () {
    return {
      showTooltip: false,
    };
  },
  mounted () {
    this.fetchUnseenNotifications();
  },
  methods: {
    notificationClick (activityId) {
      this.markNotificationAsRead(activityId);
      const route = this.getNotificationRouteById(activityId);
      if (route) {
        this.showTooltip = false;
        this.$router.push(route);
      }
    },
    notificationBellClick () {
      this.markAllNotificationsAsSeen();
      if (this.$device.isMobile) {
        this.$router.push({ name: 'dashboard::pro::notifications' });
      } else {
        this.showTooltip = !this.showTooltip;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.TOOLTIP {
  $tooltip-background-color: white;
  $tooltip-width: 500px;
  $tooltip-box-shadow: 0 4px 8px 0 $color-gray50;

  z-index: 1;
  position: absolute;
  width: $tooltip-width;
  top: 100%;
  right: 0;
  box-shadow: $tooltip-box-shadow;
  background-color: $tooltip-background-color;

  &:before, &:after {
    $size: 10px;
    $offset: 16px;
    @include square($size);
    content: '';
    position: absolute;
    right: 0;
    top: -$size/2;
    transform: rotate(45deg) translate3d(-$offset, $offset, 0);
  }

  &:before {
    z-index: -1;
    box-shadow: $tooltip-box-shadow;
  }

  .TOOLTIP-CONTENT {
    background-color: $tooltip-background-color;
    overflow: auto;
    max-height: 80vh;
  }

  &:after {
    z-index: 1;
    background-color: $tooltip-background-color;
  }
}
</style>
